var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default (function (state, action) {
    var _a;
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case 'SET_APP_STATE':
            if (!action.key && !action.value)
                return state;
            return __assign(__assign({}, state), (_a = {}, _a[action.key] = action.value, _a));
        default:
            return state;
    }
});
